import type { LucideIcon } from "lucide-react";

interface Props {
  icon: LucideIcon;
  id: string;
  children: React.ReactNode;
}

export const SectionHeading = ({ icon: Icon, id, children }: Props) => (
  <h3 id={id} className="not-prose flex items-center gap-3 mt-10 mb-4 scroll-mt-24">
    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 text-primary flex-shrink-0 ring-1 ring-primary/15">
      <Icon className="w-5 h-5" strokeWidth={2.25} />
    </span>
    <span className="text-lg sm:text-2xl font-bold text-foreground tracking-tight">{children}</span>
  </h3>
);
